"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
function useColumns(options) {
    const intl = react_intl_1.useIntl();
    const columns = react_1.useMemo(() => {
        var _a;
        return [
            ...((_a = options.columns) !== null && _a !== void 0 ? _a : []),
            {
                datakey: 'created',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_CREATED',
                    defaultMessage: 'Vytvoření',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.DateTimeCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'updated',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_UPDATED',
                    defaultMessage: 'Poslední úprava',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.DateTimeCell,
                sortable: true,
                filterable: true,
            },
        ];
    }, [options.columns, intl]);
    return columns;
}
exports.useColumns = useColumns;
//# sourceMappingURL=dated-columns.js.map